/* Zubehör-Übersicht „Dezent“ (25.10.2026, sections/sushi-dzz-main.liquid, [data-zb]) – Bike-Wahl (nur auf der Seite, seit 03.11.2026 nicht mehr gemerkt;
   gelesen auch aus ?modell= wie im Ersatzteilfinder), Rahmennummer / Bike-ID, Kategorien, Im Angebot, Sortierung.
   27.10.2026: Kopf „Zwei Schritte“ – ① Für welches Bike? (Chips mit Jahren, Rahmennummer zum Aufklappen) ② Was suchst du? (Kategorien).
   Ohne Kategorie/Angebot/Sortierung: Ansicht „Anlässe“, sonst Ansicht „Raster“ (wie Entwurf „Weißraum“).
   Plus-Knopf: /cart/add.js + Cart-Drawer des Themes (wie sushi-dezent-pdp.js). */
(function () {
  if (window.__sushiZb) return;
  window.__sushiZb = true;
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const GEN = { '30p': { s: '3.0+', l: 'SUSHI BIKE 3.0+' }, '30': { s: '3.0', l: 'SUSHI BIKE 3.0' }, plus: { s: '+', l: 'Maki+ / California Roll+' },
    g1: { s: '1. Gen', l: 'SUSHI BIKE der 1. Generation' }, tabi: { s: 'TABI', l: 'SUSHI BIKE TABI' } };
  const FROM_URL = { gen3plus: '30p', gen3: '30', gen2: 'plus', gen2_asia: 'plus', gen2_spain: 'plus', gen1: 'g1', tabi: 'tabi' },
    TO_URL = { '30p': 'gen3plus', '30': 'gen3', plus: 'gen2', g1: 'gen1', tabi: 'tabi' };
  const teile = (n) => (n === 1 ? '1 Teil' : n + ' Teile');
  const HINT = 'Groß-/Kleinschreibung und Leerzeichen sind egal.';

  /* Rahmennummer / Bike-ID → Generation. 1:1 wie im Ersatzteilfinder (dort aus dem Diagnose-Tool des Partnerportals,
     sushi-partnerportal/src/lib/frameNumberParser.ts → inferGenerationFromFrameNumber). Ändert sich die Erkennung dort, hier mitziehen. */
  const YL = { D: 2022, E: 2023, F: 2024, G: 2025, H: 2026, I: 2027 };
  function inferGen(raw) {
    const n = (raw || '').replace(/[\s-]+/g, '').toUpperCase();
    if (!n) return null;
    if (n.indexOf('SU2025') === 0) return { g: '30p', c: 'high', m: null };
    if (/^(75|85)\d/.test(n) && /^\d+$/.test(n)) return { g: '30', c: 'high', m: null };
    if (/^S[MC]/.test(n)) {
      const m = n[1] === 'M' ? 'Maki' : 'California Roll', y = n.length >= 9 ? YL[n[8]] || null : null;
      if (y === null) return { g: '30', c: 'medium', m };
      if (y < 2025) return { g: '30', c: 'high', m };
      if (y === 2025) return { g: '30p', c: 'medium', m };
      return { g: '30p', c: 'high', m };
    }
    if (n.indexOf('SB') === 0) { const l = n.length >= 5 ? n[4] : null; return { g: 'plus', c: 'high', m: l === 'M' ? 'Maki' : l === 'C' ? 'California Roll' : null }; }
    if (n.indexOf('AI') === 0 || n.indexOf('22') === 0) return { g: 'plus', c: 'high', m: null };
    if (n.indexOf('SU') === 0) return { g: 'g1', c: 'high', m: null };
    return null;
  }

  /* Der Knopf zeigt den Stand (is-busy → is-done ✓). Danach öffnet sich die Warenkorb-Meldung des Themes; klappt die nicht,
     kommt der eigene Hinweis mit Link zum Warenkorb. Fehler der Theme-Skripte halten das nicht mehr auf (25.10.2026). */
  async function addToCart(variantId, btn, toast) {
    if (btn.classList.contains('is-busy')) return;
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const body = { items: [{ id: +variantId, quantity: 1 }] };
    if (cart && cart.getSectionsToRender) {
      body.sections = cart.getSectionsToRender().map((s) => s.id).join(',');
      body.sections_url = location.pathname;
    }
    btn.classList.remove('is-done');
    btn.classList.add('is-busy');
    btn.setAttribute('aria-busy', 'true');
    let res;
    try {
      const r = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) });
      res = await r.json();
      if (!r.ok || res.status) throw res;
    } catch (err) {
      toast((err && err.description) || 'Das hat leider nicht geklappt. Bitte versuch es noch einmal.');
      return;
    } finally {
      btn.classList.remove('is-busy');
      btn.removeAttribute('aria-busy');
    }
    btn.classList.add('is-done');
    clearTimeout(btn._t);
    btn._t = setTimeout(() => btn.classList.remove('is-done'), 2600);
    const first = res.items && res.items[0];
    if (first) { res.key = first.key; res.id = first.variant_id; }
    let shown = false;
    try {
      if (cart && cart.renderContents && res.sections) {
        if (cart.setActiveElement) cart.setActiveElement(btn);
        cart.classList.remove('is-empty');
        cart.renderContents(res);
        shown = true;
      }
    } catch (e) { console.warn('sushi-dezent-zb: Warenkorb-Meldung', e); }
    try { if (typeof publish === 'function' && window.PUB_SUB_EVENTS) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'sushi-dezent-zb', productVariantId: +variantId, cartData: res }); } catch (e) {}
    if (!shown) toast((btn.dataset.name || 'Das Teil') + ' liegt im Warenkorb.', { href: root + 'cart', text: 'Zum Warenkorb' });
  }

  function init(el) {
    const S = { gen: '', cat: '', sale: false, sort: 'rank' };
    let CATS = {};
    try { CATS = JSON.parse(el.dataset.cats || '{}'); } catch (e) {}
    try { const m = new URLSearchParams(location.search).get('modell'); if (m && FROM_URL[m]) S.gen = FROM_URL[m]; } catch (e) {}
    /* ?kategorie= aus dem Kopf-Menü „Dezent“ (25.10.2026): öffnet direkt die Rasteransicht dieser Kategorie */
    let catFromUrl = '';
    try { const k = new URLSearchParams(location.search).get('kategorie'); if (k && CATS[k]) catFromUrl = S.cat = k; } catch (e) {}
    let VIEW = 'anlaesse', tT;
    const toast = (t, link) => {
      const e = $('[data-toast]', el);
      if (!e) return;
      e.textContent = t;
      if (link) { const a = document.createElement('a'); a.href = link.href; a.textContent = link.text; e.append(a); }
      e.hidden = false;
      clearTimeout(tT);
      tT = setTimeout(() => (e.hidden = true), link ? 5000 : 3200);
    };

    function sortAll() {
      $$('[data-grid]', el).forEach((g) => {
        const cs = $$(':scope>[data-p]', g);
        cs.sort((a, b) => (S.sort === 'rank' ? a.dataset.rank - b.dataset.rank : S.sort === 'asc' ? a.dataset.price - b.dataset.price : b.dataset.price - a.dataset.price));
        cs.forEach((c, i) => (c.style.order = 2 * i + 2));
      });
    }
    function apply() {
      $$('[data-p]', el).forEach((c) => {
        const fit = !S.gen || c.dataset.fit.split(' ').includes(S.gen);
        c.hidden = !(fit && (!S.cat || c.dataset.cat === S.cat) && (!S.sale || c.hasAttribute('data-sale')));
        $$('[data-fitmsg]', c).forEach((m) => { m.hidden = !S.gen; if (S.gen) m.textContent = 'Passt an dein ' + GEN[S.gen].s; });
      });
      $$('[data-group]', el).forEach((g) => { const n = $$('[data-p]', g).filter((c) => !c.hidden).length; if (g.hasAttribute('data-hideempty')) g.hidden = n === 0; });
      const vis = new Set($$('[data-scope] [data-p]', el).filter((c) => !c.hidden).map((c) => c.dataset.h));
      $$('[data-count]', el).forEach((e) => (e.textContent = teile(vis.size) + (S.gen ? ' passen an dein ' + GEN[S.gen].l : '')));
      $$('[data-empty]', el).forEach((e) => (e.hidden = vis.size > 0));
      $$('[data-gen]', el).forEach((b) => b.setAttribute('aria-pressed', b.dataset.gen === S.gen));
      $$('.zb-chips--gen', el).forEach((r) => { const b = $('[aria-pressed=true]', r); if (b && r.scrollWidth > r.clientWidth) r.scrollLeft = Math.max(0, b.offsetLeft - r.offsetLeft - 16); });
      $$('[data-fcat]', el).forEach((b) => b.setAttribute('aria-pressed', !S.sale && b.dataset.fcat === S.cat));
      $$('[data-fsale]', el).forEach((b) => b.setAttribute('aria-pressed', S.sale));
      $$('[data-chap]', el).forEach((c) => { const a = $('.zb-jump a[href="#' + c.dataset.chap + '"]', el); if (a) a.hidden = c.hidden; });
      const v = S.cat || S.sale || S.sort !== 'rank' ? 'raster' : 'anlaesse';
      $$('[data-view]', el).forEach((e) => (e.hidden = e.dataset.view !== v));
      const t = $('[data-rastertitle]', el);
      if (t) t.textContent = S.sale ? 'Im Angebot' : S.cat ? CATS[S.cat] || 'Zubehör' : 'Alles Zubehör';
      /* Ersatzteilfinder bekommt das Modell mit (?modell= wie dort) */
      $$('a[href*="/pages/ersatzteilfinder"]').forEach((a) => {
        const u = new URL(a.href, location.href);
        if (TO_URL[S.gen]) u.searchParams.set('modell', TO_URL[S.gen]); else u.searchParams.delete('modell');
        a.href = u.pathname + u.search + u.hash;
      });
      if (v !== VIEW) { VIEW = v; const f = $('#filter', el); if (f && f.getBoundingClientRect().top < 0) f.scrollIntoView({ behavior: 'smooth' }); }
      sortAll();
    }
    const setGen = (g) => { S.gen = g; apply(); };

    el.addEventListener('click', (e) => {
      const g = e.target.closest('[data-gen]');
      if (g) {
        setGen(g.dataset.gen);
        const o = $('[data-frame-out]', el), i = $('[data-frame-in]', el);
        if (o) { o.className = 'zb-frame__out'; o.textContent = HINT; }
        if (i) i.value = '';
        return;
      }
      const c = e.target.closest('[data-fcat]');
      if (c) { S.cat = c.dataset.fcat; S.sale = false; apply(); return; }
      if (e.target.closest('[data-fsale]')) { S.sale = !S.sale; S.cat = ''; apply(); return; }
      if (e.target.closest('[data-backview]')) { S.cat = ''; S.sale = false; S.sort = 'rank'; $$('[data-sort]', el).forEach((x) => (x.value = 'rank')); apply(); return; }
      const a = e.target.closest('[data-add]');
      if (a) addToCart(a.dataset.variant, a, toast);
    });
    el.addEventListener('change', (e) => {
      if (e.target.matches('[data-sort]')) { S.sort = e.target.value; $$('[data-sort]', el).forEach((s) => (s.value = S.sort)); apply(); }
    });
    el.addEventListener('submit', (e) => {
      const f = e.target.closest('[data-frame]');
      if (!f) return;
      e.preventDefault();
      const raw = $('[data-frame-in]', f).value, out = $('[data-frame-out]', el), n = raw.replace(/[\s-]+/g, '');
      out.className = 'zb-frame__out';
      if (!n) { out.classList.add('no'); out.textContent = 'Bitte gib deine Rahmennummer oder Bike-ID ein.'; return; }
      if (n.length < 6) { out.classList.add('no'); out.textContent = 'Bitte gib mindestens 6 Zeichen deiner Rahmennummer oder Bike-ID ein.'; return; }
      const r = inferGen(raw);
      if (!r) { out.classList.add('no'); out.textContent = 'Diese Nummer konnten wir keinem Modell zuordnen. Bitte prüf deine Eingabe – oder wähl dein Modell oben aus.'; return; }
      setGen(r.g);
      out.classList.add('ok');
      out.textContent = '✓ Erkannt: ' + GEN[r.g].l + (r.m ? ' · ' + r.m : '') + '. Wir zeigen dir nur Zubehör, das passt.' +
        (r.c === 'medium' ? ' Bei dieser Nummer sind wir uns nicht ganz sicher, ob es ein 3.0 oder 3.0+ ist – stimmt es nicht, wähl dein Modell oben aus.' : '');
    });
    apply();
    if (catFromUrl) {
      const go = () => {
        const f = $('#filter', el), hh = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
        if (f && window.scrollY < 10) window.scrollTo(0, f.getBoundingClientRect().top + window.scrollY - hh - 12);
      };
      if (document.readyState === 'complete') setTimeout(go, 60); else addEventListener('load', () => setTimeout(go, 60), { once: true });
    }
  }

  const start = () => $$('[data-zb]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  /* Theme-Editor: neu geladene Section wieder verdrahten */
  document.addEventListener('shopify:section:load', (e) => $$('[data-zb]', e.target).forEach(init));
})();
